<script setup>
import { toRefs } from 'vue';
import { ListboxProvider } from './useListbox';

/**
 * @typedef {object} ListboxProps
 * @property {('xs'|'sm'|'default')} [size='default'] - Size of the listbox item
 */

/**
 * @type {ListboxProps}
 */
const props = defineProps({
  size: {
    type: String,
    default: 'default',
  },
});

ListboxProvider({
  rootProps: toRefs(props),
});
</script>

<template>
  <div
    data-component="CsListbox"
    :data-size="props.size"
    class="flex flex-col gap-0.5 py-2 px-1.5"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>
